import 'babel-polyfill'
// import Vue from 'vue'
// import Vuex from 'vuex'
import cookie from 'js-cookie'

// Vue.use(Vuex)

const state = {
	platform: null,
	/**
	 @ taskGroup 选中的是任务群
	 @ tasek 选中的是任务
	 @ taskChildren 选中的是子任务
	 */
	choiceType: '',    //内容的状态
	createDesign: '',  //创建成功状态
	leftInfo: {},  //左侧选中的数据等
	designCatalog: null, // 单个学习设计内部的章节信息
	home: {           //中转页面的home
		shadow: false
	},
	account: {    //账号信息
		Account: null
	},
	dotMatrixPen: {
		mode: "paperWrite"
	},
	enterClassConfig: {
		resList: [],
	},
	taskChildrenParentInfo: {},
	catlogAllIdxObj: {},
	makeBtnMovedFlag: true,
	reloadConnectFlag:false,
	questionObj:{},
	//编辑交互题 begin
	resourceQuestionList: [],
	anchorPoint: -1,
	videoInfo: null,
	existedList: [],//已添加试题列表中的数据
	hasAddQuestionList: [],
	modelData: null,
	SPRList: [],
	allQuestionList: [],//与创建接口交互的总非视频试题列表，增删改查都在其中操作
	allVideoQuestionList: [],//视频题
	allTaskData:[],//task内所有数据
	//编辑交互题 end
	catch_components: [],//被缓存的组件
	playingVedioId: 0, // 记录播放vedio的Id
	playEId:0,

	//学程设计的详情页下面的相关存储
	allDisplayFlag:false,
	taskGroupObj:{},
	resPreviewObj:{
		resItem:null,
		openFlag:false,
		data:null,
		taskId:null
	},
	allResource: {},

	taskData: {}, // 记录任务内容
	basedInfo:{},
	styleFlag:0,
	courseInfo:null,
	courseId:'',

	leftTaskFlag:false,
	rightTaskFlag:false,
	taskItemInfo:null,
	checkItem:null,
	navDisplayBtn:true,
	activeScenesImgUrl:null,
	audioUrl:null,
	guideConfig:null,
	dsGuideContent:[],
	playingAudioId:null,
	createTaskContent:null,//新建学程设计内容中每一个模块的初始item值
	toolSetObj:{
		setFlag:false,
		setType:null
	},//工具集的type值
	resPreviewBackFlag:false,
	designIntro:{
		guid:null,
		text:null
	},
	fromOtherSite:{
		name:'',
		role:''
	},
	teachFullScreen:false
}
const mutations = {
	setTaskData(state, val){
		state.taskData = val
	},
	/* 记录所有的资源 */
	setAllResource(state, val){
		state.allResource[val.eId] = val.items
	},
	setPlayingVedioId(state, val){
		state.playingVedioId = val
	},
	changeType(state, val) {
		state.choiceType = val
	},
	changeCreate(state, val) {
		state.createDesign = val
	},
	changeLeftInfo(state, val) {
		state.leftInfo = val
	},
	changeLeftTaskParentInfo(state, val) {
		state.taskChildrenParentInfo = val;
	},
	UPDATE_DESIGN_CATALOG(state, val) {
		state.designCatalog = val
	},
	CLOSE_HOME_SHADOW(state) {
		state.home.shadow = false
	},
	OPEN_HOME_SHADOW(state) {
		state.home.shadow = true
	},
	UPDATE_PLATFORM(state, payload) {
		// console.log(payload)
		state.platform = payload.platform
	},
	UPDATE_ACCOUNT(state, payload) {
		let account = payload.account.Account;
		state.account.Account = account
		var date = new Date();
		var nightDate = date.toLocaleDateString() + " " + "23:59:59";
		var span = (new Date(nightDate) - new Date()) / 1000 / 3600 / 24;
		var cookieOptions = { expires: span, path: '/' };
		var hostName = window.location.hostname;
		var domain = hostName;
		var domainArr = domain.split('.');
		var arrLength = domainArr.length;
		if (arrLength >= 2) {
			domain = domainArr[arrLength - 2] + "." + domainArr[arrLength - 1];
		}
		if (domain != 'localhost') {
			cookieOptions.domain = domain;
		}
		if (account != null) {
			//sessionStorage.setItem('account', JSON.stringify(account));
			cookie.set('account', account, cookieOptions);
		}
	},
	UPDATE_DotMatrixPen(state, val) {
		state.dotMatrixPen.mode = val
	},
	UPDATE_ENTERCLASS_LIST(state, val) {
		state.enterClassConfig.resList = val
	},
	CATLOG_ALL_IDX_OBJ(state, val) {
		state.catlogAllIdxObj = val;
	},
	MAKEBTNMOVED(state, flag) {
		state.makeBtnMovedFlag = flag;
	},

	PLAY_TEXT(state,eId){
		state.playEId = eId
	},

	/* 教师端编辑互动题 Start */
	SET_VIDEOINFO(state, videoInfo) {
		state.videoInfo = videoInfo
	},
	SET_ANCHORPOINT(state, anchorPoint) {
		state.anchorPoint = anchorPoint
	},
	SET_RESOURCEQUESTIONLIST(state, data) {
		data.ResourceIdx = data.ResourceIdx + "";
		data.AnchorPoint = data.AnchorPoint + "";
		state.resourceQuestionList.push(data)
	},
	CLEAN_RESOURCEQUESTIONLIST(state) {
		state.resourceQuestionList = []
	},
	DELETE_RESOURCEQUESTIONLIST(state, qid) {
		let list = state.resourceQuestionList
		if (list.length > 0) {
			for (var i = 0; i < list.length; i++) {
				if (list[i].QuestionIdx == qid) {
					list.splice(i, 1)
				}
			}
		}
	},
	SET_EXISTEDLIST(state, list) {
		list.forEach(element => {
			state.existedList.push(element)
		});
	},
	DELETE_EXISTEDLIST(state, id) {
		for (let i = 0; i < state.existedList.length; i++) {
			if (state.existedList[i].QuestionIdx == id || state.existedList[i].qid == id || state.existedList[i].Idx == id) {
				state.existedList.splice(i, 1)
			}
			/* if(state.existedList[i].qid==id||state.existedList[i].Idx==id){
				state.existedList.splice(i,1)
			} */
		}
	},
	CLEAN_EXISTEDLIST(state) {
		state.existedList = []
	},
	SET_HASADDQUESTIONLIST(state, list) {//该任务下的所有交互题，编辑功能需要
		state.hasAddQuestionList = list
	},
	SET_MODELDATA(state, data) {//点击的资源的信息，编辑功能需要
		state.modelData = data
	},
	ADD_MODELDATA(state, data) {//未点击总保存的交互题信息，编辑功能需要
		state.modelData.push(data)
	},
	SET_SPRLIST(state, data) {
		state.SPRList = data
	},
	/* 教师端编辑互动题 End */
	/* 2.0编辑互动题 Start */
	SET_ALLQUESTIONLIST(state, data) {//非视频试题
		state.allQuestionList = data
	},
	ADD_QUESTION(state, data) {//添加试题
		state.allQuestionList.questions.push(data)
	},
	DELETE_QUESTION(state, id){//删除试题
		state.allQuestionList.questions.forEach((item,index) =>{
			if(item.questionIdx == id){
				state.allQuestionList.questions.splice(index,1)
			}
		})
	},
	SET_VIDEOALLQUESTIONLIST(state, data) {//视频试题
		state.allVideoQuestionList = data
	},
	ADD_VIDEOQUESTION(state, data) {//添加试题
		state.allTaskData[data.componentIndex].videos[data.index].userQuestion.push(data.question)
		// state.allVideoQuestionList.videos[data.index].userQuestion.push(data.question)
	},
	DELETE_VIDEOQUESTION(state, data){//删除试题
		// state.allVideoQuestionList.videos[data.index].userQuestion.forEach((item,index) =>{
		// 	if(item.questionIdx == data.id){
		// 		state.allVideoQuestionList.videos[data.index].userQuestion.splice(index,1)
		// 	}
		// })
		state.allTaskData[data.componentIndex].videos[data.index].userQuestion.forEach((item,index) =>{
			if(item.questionIdx == data.id){
				state.allTaskData[data.componentIndex].videos[data.index].userQuestion.splice(index,1)
			}
		})
	},
	ADD_VIDEO(state, data){//添加视频
		if(state.allVideoQuestionList.videos.length>0){
			state.allVideoQuestionList.videos.push(data.videos)
		}else{
			let videos = []
			videos.push(data.videos)
			state.allVideoQuestionList.push({videos:videos})
		}
		
	},
	INIT_ALLTASKDATA(state, data){//视频交互题数据
		if(data){
			state.allTaskData = data
		}
	},
	DELETE_VIDEO(state, data){
		state.allTaskData[data.componentIndex].videos.splice(data.videoIndex,1)
	},
	/* 2.0编辑互动题 End */
	//条件缓存组件
	GET_CATCHE_COMPONENTS (state, data) {
		state.catch_components = data
	},

	RELOAD_CONNECT(state,questionObj){
		state.questionObj = questionObj;
		state.reloadConnectFlag = !state.reloadConnectFlag;
	},


	//学程设计的详情页下面的相关存储逻辑

	DISPLAY_ALL_TASK(state,allDisplayFlag){
		state.allDisplayFlag = allDisplayFlag;
	},
	TASK_GROUP_OBJ(state,obj){
		state.taskGroupObj = obj;
	},
	RES_PREVIEW(state,obj){
		if(obj){
			state.resPreviewObj.openFlag = true
		}else{
			state.resPreviewObj.openFlag = false;
			return
		}
		state.resPreviewObj.resItem = obj.resItem;
		state.resPreviewObj.data = obj.data;
		state.resPreviewObj.taskId = obj.taskId;
	},
	GET_BASED_INFO(state,basedInfo){
		state.basedInfo = basedInfo;
	},
	SAVE_STYLEFLAG(state,styleFlag){
		state.styleFlag = styleFlag;
	},
	COURSE_INFO(state,courseInfo){
		state.courseInfo = courseInfo;
	},
	SET_COURSE_ID(state,courseId){
		state.courseId = courseId;
	},
	LEFT_TASK_CLICK(state){
		state.leftTaskFlag = !state.leftTaskFlag
	},
	RIGHT_TASK_CLICK(state){
		state.rightTaskFlag = !state.rightTaskFlag
	},
	SAVE_TASK_ITEM_INFO(state,info){
		state.taskItemInfo = info;
	},
	CHECK_ITEM(state,item){
		state.checkItem = item;
	},
	NAV_DISPLAY_SHRINK_CHANGE(state){
		state.navDisplayBtn = !state.navDisplayBtn;
	},
	UPDATE_SECEN_IMG(state,url){
		state.activeScenesImgUrl = url
	},
	SET_GUIDE_AUDIO_URL(state,audioUrl){
		state.audioUrl = audioUrl;
	},
	GET_TASK_GUIDE(state,config){
		state.guideConfig = config
	},
	DS_GUIDE_CONTENT(state,list){
		state.dsGuideContent = list;
	},
	PLAYING_AUDIO_ID(state,id){
		state.playingAudioId = id;
	},
	SAVE_TASK_CONTENT_ITEM(state,item){
		state.createTaskContent = item;
	},
	CREATE_TOOL_SET(state,type){
		state.toolSetObj.setFlag = !state.toolSetObj.setFlag;
		state.toolSetObj.setType = type;
	},
	RES_PREVIEW_BACK(state){
		state.resPreviewBackFlag = !state.resPreviewBackFlag;
	},
	SAVE_DESIGN_RICH_INTRO(state,info){
		Object.assign(state.designIntro,info)
	},
	UPDATE_FROMOTHERSITE(state,data){
		state.fromOtherSite.name = data.data.name
		state.fromOtherSite.role = data.data.role
	},
	SAVE_TEACH_FULL_SCREEN(state,fullScreen){
		state.teachFullScreen = fullScreen;
	}
}
export default new Vuex.Store({
	state,
	mutations,
})



// WEBPACK FOOTER //
// ./src/vuex/store.js